// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b1d9e27","455":"def1e799","977":"d7ae8e29"}[chunkId] + ".chunk.js";
};